<template>
  <div class="performance-form">
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      label-width="120px"
      style="overflow: auto"
    >
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="业绩确认单" name="first">
          <el-scrollbar>
            <div class="table-form">
              <div class="form-logo">
                <div style="width: 100%">
                  <p class="form-name">业绩确认单<span style="color:red;font-size: 15px;">-{{form.fBillType}}</span></p>
                </div>
              </div>
              <div class="form-info">
                <p>单号：{{ form.fBillNo }}</p>
                <p>经销商：{{ form.fDistributor }}</p>
                <p>
                  客户名称：{{ form.fCustomer }}
                  <span>时间：{{ form.fDate }}</span>
                </p>
              </div>
              <el-table
                :data="pTableData"
                border
                :span-method="objectSpanMethod"
                style="width: 100%"
              >
                <el-table-column prop="fNumber" label="产品编号" width="" />
                <el-table-column prop="fName" label="产品名称" width="" />
                <el-table-column prop="fModel" label="规格" width="" />
                <el-table-column prop="fQty" label="数量" width="" />
                <el-table-column prop="fPrice" label="销售单价" width="" />
                <el-table-column v-if="form.fBillType=='退货单' " prop="fDeductionRatio" label="退款比例(%)" width="" />
                <el-table-column prop="total" label="小计" width="" />
              </el-table>
              <div style="text-align:right;padding-right:2%;margin-top:10px;">
                合计:{{ total }}
              </div>
              <hr v-if="form.fBillType!='退货单'">
              <div v-if="form.fBillType!='退货单'" style="text-align:right;padding-right:2%;margin-bottom:3%;">
                付款比例:{{ form.fDeductionRatio }}%
                付款金额:{{ totalRatio }}
              </div>
            </div>
            <el-button
              type="primary"
              :disabled="saving"
              style="margin: 10px auto; text-align: center"
              @click="submit(1)"
            >确认</el-button>
          </el-scrollbar>

        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
import ReturnNode from '@components/ReturnNode'

export default {
  inject: ['getMap'],
  data: function() {
    return {
      form: {},
      pTableData: [],
      rules: {},

      activeName: 'first',

      saving: false,
      loading: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    total: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return t.toFixed(2)
    },
    totalRatio: function() {
      var t = this.form.entrys.reduce((sum, item) => {
        return Number(sum) + Number(item.total)
      }, 0)
      return (t * Number(this.form.fDeductionRatio) / 100).toFixed(2)
    }
  },
  mounted() {
    // console.log(this.form, 'this.form')
  },
  methods: {
    submit: function() {
      this.$refs.form.validate(async(valid) => {
        if (valid) {
          const flg = await this.confirm('是否提交?')
          if (!flg) return
          this.form.entrys.splice(-1, 1)

          this.$httpPost('OrderManage/Achievement/AchievementConfirm', {
            fid: this.form.fid
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              // if (res.datalist) this.refresh(res.datalist);

              if (this.$route.query.ishome) {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/' })
              } else {
                const tabName = this.$store.state.tabName
                this.getMap(tabName)
                this.$router.push({ path: '/orderManage/performanceAffirm' })
              }
            })
            .finally(() => (this.saving = false))
        } else {
          this.activeName = 'first'
          return false
        }
      })
    },

    confirm: function(msg) {
      return this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => true)
        .catch(() => false)
    },

    refresh: async function(fid) {
      const id = fid || +this.$route.params.id

      const res = await this.$httpPost(
        'OrderManage/Achievement/GetAchievement',
        {
          fid: id
        }
      )

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }
      // console.log(res, 'res')
      this.form = res.datalist
      this.pTableData = res.datalist.entrys
      /*
      const newob2 = Object.assign({
        fNumber: '合计',
        fName: this.form.fAmount
      })
      this.pTableData.push(newob2)
      */
    },
    /*
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(rowIndex, 'rowIndex')
      // console.log(columnIndex, 'columnIndex')
      const rowlength1 = this.pTableData.length - 1

      if (rowIndex === rowlength1) {
        if (columnIndex === 0) {
          return [1, 5]
        }
      }
      // if (columnIndex === 0) {
      //   if (rowIndex === rowlength2) {
      //     return {
      //       rowspan: 2, // 多少行合并
      //       colspan: 1 // 多少列合并
      //     }
      //   }
      // }
    }*/
  }
}
</script>

<style lang="less" scoped>
</style>
<style lang="less">
.performance-form {
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
  .el-tabs {
    .el-tabs__content {
      height: calc(100vh - 200px);
      .el-tab-pane {
        height: calc(100vh - 200px);
      }
    }
  }
  .formitem {
    .el-form-item__label {
      margin: 26px 0;
      // width: 78px !important;
    }
    .el-form-item__content {
      // margin-left: 89px !important;
    }
  }

  .table-form {
    width: 99%;
    table {
      font-size: 12px;
    }
    .el-table {
      color: #000;
    }
    .el-table td,
    .el-table th {
      // padding: 0px 0;
    }
    .el-table__header tr,
    .el-table__header th {
      padding: 0;
    }
    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: black;
    }
    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: black;
    }
    .el-table thead {
      color: #000;
      font-weight: 500;
    }

    .form-logo {
      display: flex;
      div {
        flex-direction: column;
      }

      .form-name {
        font-weight: bold;
        font-size: 25px;
        font-family: 华文行楷;
        margin: 0 auto;
        text-align: center;
      }
      p {
        margin: 0px;
      }
      .fCompany {
        height: 40px;
        line-height: 40px;
        font-size: 13px;
      }
      .fCompanyEnglish {
        font-size: 7px;
        height: 8px;
      }
    }
    .form-info {
      font-size: 14px;
      span {
        float: right;
        // text-align: right;
        margin-left: 35px;
      }
    }

    .a-Table {
      border-collapse: collapse;
      width: 100%;
      // text-align: center;
      // border: 1px solid #000;
      tr {
        display: flex;
        border-right: 1px solid #000;
        td {
          flex: 1;
          border-bottom: none;
          border-right: none;
        }
        th {
          flex: 1;
          text-align: left;
          border-bottom: none;
          border-right: none;
        }
      }
      table,
      td,
      th {
        border: 1px solid #000;
      }
    }
  }
}
</style>
